import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import Swal from 'sweetalert2';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Initialize EmailJS with your public key
    emailjs.init('YOUR_PUBLIC_KEY'); // Replace with your actual public key

    emailjs.send(
      'service_aorriqm',  // Replace with your EmailJS service ID
      'template_uyrrl67',  // Replace with your EmailJS template ID
      formData,           // Your form data (object)
      'kWGxJs7MSfdc4XlRu'   // Use the public key as the user ID here
    )
    .then((response) => {
      console.log('SUCCESS!', response.status, response.text);
      Swal.fire({
        icon: 'success',
        title: 'Thank you!',
        text: 'Thanks for contacting us. We will get back to you soon.',
      });
      setFormData({ name: '', email: '', message: '' });  // Reset the form fields
    }, (error) => {
      console.log('FAILED...', error);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Something went wrong. Please try again later.',
      });
    });
  };

  return (
    <div className='flex justify-center items-center h-[100vh] w-full bg-[#eeeeee]'>
      <form className="colorful-form" onSubmit={handleSubmit}>
        <div className='sm:text-[1.5rem] md:text-[2rem] font-bold text-center'>
          We <span className='text-[#FF6500]'>Waiting</span> For Your Mail
        </div>
        <div className="form-group mt-3">
          <label className="form-label" htmlFor="name">Name:</label>
          <input
            required
            placeholder="Enter your name"
            className="form-input"
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label className="form-label" htmlFor="email">Email:</label>
          <input
            required
            placeholder="Enter your email"
            className="form-input"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label className="form-label" htmlFor="message">Message:</label>
          <textarea
            required
            placeholder="Enter your message"
            className="form-input"
            name="message"
            value={formData.message}
            onChange={handleChange}
          />
        </div>
        <button className="form-button" type="submit">Submit</button>
      </form>
    </div>
  );
};

export default Contact;
